/** Stub until registration feedback API is available. */
export async function submitRegistrationFeedback(_rating: number): Promise<void> {
  // TODO: integrate registration NPS feedback API when backend spec is ready.
  await Promise.resolve();
}
